import { cn } from "utils";

interface RsiGaugeBarProps {
  /** Gauge value 0–100; also drives indicator position when `indicatorPosition` omitted */
  rsiValue: number;
  /** Optional override for marker position (0–100) */
  indicatorPosition?: number;
  /** Screen-reader label prefix, e.g. RSI / KDJ */
  gaugeLabel?: string;
  className?: string;
}

/**
 * RSI 三色区间仪表条。 Figma：94103:23212
 */
export const RsiGaugeBar: React.FC<RsiGaugeBarProps> = ({
  rsiValue,
  indicatorPosition,
  gaugeLabel = "RSI",
  className,
}) => {
  const markerPercent = Math.min(
    100,
    Math.max(0, indicatorPosition ?? rsiValue),
  );

  return (
    <div className={cn("flex w-[160px] flex-col gap-0.5", className)}>
      <div className="relative h-2 w-full">
        <div
          className="absolute top-0 size-0 -translate-x-1/2 border-x-[4px] border-x-transparent border-t-[5px] border-t-content_accent2_primary"
          style={{ left: `${markerPercent}%` }}
          aria-hidden
        />
      </div>
      <div className="flex w-full gap-0.5 overflow-hidden rounded-1">
        <div className="h-3 flex-1 bg-background_accent1_overlay40" />
        <div className="h-3 flex-1 bg-content_accent5_tertiary/40" />
        <div className="h-3 flex-1 bg-background_accent2_overlay40" />
      </div>
      <div className="relative h-3 w-full body_medium_xs text-content_quaternary">
        <span className="absolute left-[32%] -translate-x-1/2">30</span>
        <span className="absolute left-[67%] -translate-x-1/2">70</span>
      </div>
      <span className="sr-only">
        {gaugeLabel} {rsiValue}
      </span>
    </div>
  );
};
